import { jsx as c, jsxs as ut } from "react/jsx-runtime";
import { forwardRef as mt, useState as d, useRef as u, useEffect as p, useMemo as ft, useCallback as w, useImperativeHandle as pt } from "react";
import { createPortal as wt } from "react-dom";
import a from "./styles.module.less.js";
import gt from "./close-icon.svg.js";
import { useDisableScroll as It } from "../../../utils/use-disable-scroll.js";
import { PREMATTER_ID_COOKIE as _t, ATTICUS_JOB_ID_KEY as Tt, ATTICUS_EMAIL_KEY as ht, ATTICUS_PREMATTER_ID_KEY as G } from "../../../utils/atticus-storage-keys.js";
import { AiChatPromptModal as At } from "../ai-chat-prompt-modal/index.js";
import { createAtticusModal as Lt } from "./create-atticus-modal.js";
const St = 200, Et = mt(
  ({
    defaultOpen: et = !1,
    onClose: n,
    onOpen: g,
    iframeUrl: O,
    category: l = null,
    suburb: I = null,
    suburbId: P = null,
    utmContent: Y,
    fromFirm: M,
    additionalParams: s = {},
    ga4MeasurementId: m,
    onIframeLoad: N,
    onCloseWithData: $,
    onShareBriefSuccess: _,
    source: q = "lawconnect",
    user: f,
    context: j,
    showAiChatPrompt: H = !1,
    chatRedirectUrl: J = "/chat",
    isProduction: st = !0
  }, it) => {
    const [T, D] = d(et), [C, h] = d(!1), [A, z] = d(!1), [S, rt] = d(""), [L, ot] = d(""), [nt, E] = d(!1), k = u(null), i = u(null), Q = u(""), b = u(!1), U = u(null), K = u(!1);
    It({ isDisabled: T }), p(() => {
      (() => {
        if (typeof window < "u" && window.gtag)
          try {
            if (m) {
              window.gtag(
                "get",
                m,
                "client_id",
                (t) => {
                  t && rt(t);
                }
              ), window.gtag(
                "get",
                m,
                "session_id",
                (t) => {
                  t && ot(t);
                }
              );
              return;
            }
          } catch (t) {
            console.warn("Failed to get GA4 data from gtag:", t);
          }
      })();
    }, [m]);
    const v = ft(() => {
      const e = new URLSearchParams();
      Object.entries(s).forEach(([r, y]) => {
        r !== "client_id" && r !== "session_id" && e.append(r, y);
      }), S && e.append("client_id", S), L && e.append("session_id", L);
      const t = e.toString();
      return `${O}${t ? `?${t}` : ""}`;
    }, [O, s, S, L]);
    p(() => {
      v !== Q.current && z(!1), Q.current = v;
    }, [v]);
    const at = w(() => {
      i.current && (clearTimeout(i.current), i.current = null), b.current = !1, U.current = null, h(!1), E(!1), D(!0), g == null || g();
    }, [g]), x = w(() => {
      K.current || (i.current && clearTimeout(i.current), h(!0), i.current = setTimeout(() => {
        D(!1), h(!1), E(!1), n == null || n();
      }, St));
    }, [n]), R = w(() => {
      H && !b.current ? E(!0) : x();
    }, [H, x]), ct = w(
      (e) => {
        const t = new URLSearchParams({ newCase: "true", ask: e }), r = U.current || I;
        l && t.set("category", l), r && t.set("location", r), window.location.href = `${J}?${t.toString()}`;
      },
      [J, l, I]
    ), lt = w(() => {
      i.current && (clearTimeout(i.current), i.current = null), E(!1), D(!1), h(!1), K.current = !0, n == null || n(), K.current = !1;
    }, [n]);
    p(() => () => {
      i.current && clearTimeout(i.current);
    }, []);
    const dt = () => {
      z(!0), N == null || N();
    };
    return p(() => {
      T && A && setTimeout(() => {
        var e;
        if (k.current) {
          const t = {
            type: "init-atticus",
            payload: {
              category: l || null,
              suburb: I || null,
              suburbId: P || null,
              ...M ? { fromFirm: M } : {},
              utm: {
                utmSource: s.utm_source || void 0,
                utmContent: Y || void 0,
                utmCampaign: s.utm_campaign || void 0,
                utmMedium: s.utm_medium || void 0,
                utmTerm: s.utm_term || l || void 0,
                gclid: s.gclid || void 0,
                msclkid: s.msclkid || void 0,
                fbclid: s.fbclid || void 0,
                gaClientId: S || void 0
              },
              source: q,
              sourceUrl: window.location.href,
              // Include all stored query string parameters
              queryParams: s,
              // Include context if provided
              ...j ? { context: j } : {},
              // Include user if provided
              ...f ? {
                user: {
                  name: f.name,
                  email: f.email,
                  phone: f.phone
                }
              } : {}
            }
          };
          try {
            (e = k.current.contentWindow) == null || e.postMessage(t, "*");
          } catch (r) {
            console.error("❌ Error sending postMessage:", r);
          }
        }
      }, 100);
    }, [
      T,
      A,
      l,
      I,
      P,
      Y,
      M,
      s,
      q,
      j,
      f
    ]), p(() => {
      const e = async (t) => {
        var r, y, X, Z, F, W, V, B;
        if (((r = t.data) == null ? void 0 : r.type) === "close-atticus") {
          const o = {
            email: (y = t.data) == null ? void 0 : y.email,
            jobId: (X = t.data) == null ? void 0 : X.jobId
          };
          window.sessionStorage.removeItem(_t), o.jobId && window.sessionStorage.setItem(Tt, o.jobId), o.email && window.sessionStorage.setItem(ht, o.email);
          const tt = window.sessionStorage.getItem(
            G
          );
          $ ? await $(o) : tt && (window.sessionStorage.removeItem(G), window.location.href = `/case/${tt}`), b.current = !0, R();
        } else if (((Z = t.data) == null ? void 0 : Z.type) === "share-brief-success") {
          b.current = !0;
          const o = {
            prematterId: (F = t.data) == null ? void 0 : F.prematterId,
            jobId: (W = t.data) == null ? void 0 : W.jobId
          };
          o.prematterId && window.sessionStorage.setItem(
            G,
            o.prematterId
          ), _ == null || _(o);
        } else ((V = t.data) == null ? void 0 : V.type) === "atticus-context-update" && (B = t.data) != null && B.locationId && (U.current = t.data.locationId);
      };
      return window.addEventListener("message", e), () => {
        window.removeEventListener("message", e);
      };
    }, [R, $, _]), pt(it, () => ({
      openModal: at,
      closeModal: x
    })), !T && !C ? null : nt ? /* @__PURE__ */ c(
      At,
      {
        onSubmit: ct,
        onClose: lt,
        ga4MeasurementId: m,
        isProduction: st
      }
    ) : wt(
      /* @__PURE__ */ c(
        "div",
        {
          className: `${a.modal} ${C ? a.closing : ""}`,
          onClick: R,
          children: /* @__PURE__ */ ut(
            "div",
            {
              className: `${a.modalContent} ${C ? a.closing : ""}`,
              onClick: (e) => e.stopPropagation(),
              children: [
                /* @__PURE__ */ c("div", { className: a.close, onClick: R, children: /* @__PURE__ */ c(gt, {}) }),
                !A && /* @__PURE__ */ c("div", { className: a.loadingSpinner, children: /* @__PURE__ */ c("div", { className: a.spinner }) }),
                /* @__PURE__ */ c(
                  "iframe",
                  {
                    ref: k,
                    src: v,
                    width: "100%",
                    height: "100%",
                    onLoad: dt,
                    className: a.iframe,
                    title: "Atticus AI Assistant",
                    style: { opacity: A ? 1 : 0 }
                  }
                )
              ]
            }
          )
        }
      ),
      document.body
    );
  }
);
Et.displayName = "AtticusModal";
export {
  Et as AtticusModal,
  Lt as createAtticusModal
};
